import { PaymentMethodEnum } from '@/__generated_graphql__/graphql';
import { PaymentWayKey } from '@/constants/common';

export const MAX_NUMBER_LENGTH = 4;

export const WAY_TO_METHODS: Record<PaymentWayKey, PaymentMethodEnum[]> = {
  CARD: [
    PaymentMethodEnum.Azericard,
    PaymentMethodEnum.Yigim,
    PaymentMethodEnum.Goldenpay,
    PaymentMethodEnum.Kapitalbank
  ],
  PORTMANAT: [PaymentMethodEnum.Portmanat],
  WALLET: [PaymentMethodEnum.Wallet]
};

export const DEFAULT_PRIORITY: PaymentMethodEnum[] = [
  PaymentMethodEnum.Azericard,
  PaymentMethodEnum.Yigim,
  PaymentMethodEnum.Wallet,
  PaymentMethodEnum.Portmanat,
  PaymentMethodEnum.Goldenpay,
  PaymentMethodEnum.Kapitalbank
];
